/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from "react";

import { BsFillPinMapFill } from "react-icons/bs";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { FeaturesEnum } from "../../../../../shared/enums/features.enum";
import { useAuth } from "../../../../../shared/hooks/useAuth";
import { useOlMap } from "../../../../../shared/hooks/useOlMap";
import { drawAnyJSONGeometry } from "../../../../../shared/utils/ol.utils";
import { showToast } from "../../../../global/toast";

interface RecordActionsProps {
    record: Partial<any>;
    disableLocation?: boolean;
    doAfterClick?(): void;
    iconsSize?: number;
}

export const RecordAnyActions: React.FC<RecordActionsProps> = ({
    record,
    disableLocation,
    doAfterClick,
    iconsSize = 18,
}) => {
    const { user } = useAuth();
    const { map } = useOlMap();

    const canLocate =
        user.authorizationsByFeatureName?.[FeaturesEnum.ANY_SEARCH]?.canRead;

    const drawPropertyGeom = useCallback(() => {
        if (!map) return;

        if (!record.geom_geojson) {
            showToast({ type: "warn", message: "Lote não encontrado" });
            return;
        }

        drawAnyJSONGeometry({
            geometry:
                typeof record.geom_geojson === "string"
                    ? JSON.parse(record.geom_geojson)
                    : record.geom_geojson,
            map,
            padding: [180, 180, 180, 180],
        });

        doAfterClick?.();
    }, [map, doAfterClick, record.geom_geojson]);

    if (disableLocation || !canLocate) {
        return null;
    }

    return (
        !disableLocation &&
        canLocate && (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip>LOCALIZAR</Tooltip>}
            >
                <button type="button" onClick={drawPropertyGeom}>
                    <BsFillPinMapFill color="teal" size={iconsSize} />
                </button>
            </OverlayTrigger>
        )
    );
};
